import { useTranslation } from 'react-i18next'

import { cn } from '#/shared/lib/utils'

/** Small "AI" badge used on AI-generated messages and calls. `onAccent` styles
 *  it for the blue outgoing bubble (translucent white instead of soft blue). */
export function AiTag({ onAccent = false }: { onAccent?: boolean }) {
  const { t } = useTranslation()
  return (
    <span
      className={cn(
        'shrink-0 rounded px-1.25 py-px text-2xs font-semibold',
        onAccent
          ? 'bg-paper/24 text-paper'
          : 'bg-avatar-blue-soft text-avatar-blue',
      )}
    >
      {t('phonePanel.aiTag')}
    </span>
  )
}
